<script>
import { useCourseFetchStore } from "@/stores/course/course-fetch-store";
import { useUserStore } from "@/stores/user/user-store";
import { useAuthStore } from "@/stores/auth-store";
import { onMounted } from "vue";

export default {
  props: {
    hideInstructor: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const courseFetchStore = useCourseFetchStore();
    const userStore = useUserStore();
    const authStore = useAuthStore();

    onMounted(() => {
      courseFetchStore.fetchGroupList();
      courseFetchStore.fetchDifficultyList();
      courseFetchStore.fetchStatusList();
      userStore.fetchTeachers();
    });
    return { courseFetchStore, authStore, userStore };
  },
  methods: {
    clearFilters() {
      this.courseFetchStore.clearAllFilters();
    },
  },
};
</script>

<template>
  <div class="modal fade" id="filterCourseModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter Course</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>

        <div class="modal-body">
          <!-- Group Filter -->
          <label class="form-label">Group Code</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="courseFetchStore.filterGroup"
            :options="courseFetchStore.groupList"
            :reduce="(option) => option.course_group_id"
            label="code"
            placeholder="Select Group"
          />

          <!-- Difficulty Filter -->
          <label class="form-label">Difficulty</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="courseFetchStore.filterDifficulties"
            :options="courseFetchStore.difficultyList"
            placeholder="Select Difficulty"
          />

          <!-- Instructor Filter -->
          <template v-if="!hideInstructor">
            <label class="form-label">Instructor</label>
            <vSelect
              multiple
              class="vselect-custom mb-3"
              v-model="courseFetchStore.filterInstructor"
              :options="userStore.ActiveTeachers"
              placeholder="Select Instructor"
              :reduce="(user) => user.userID"
              :get-option-label="(user) => authStore.userName(user.userID)"
            />
          </template>

          <!-- Status Filter -->
          <label class="form-label">Status</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="courseFetchStore.filterStatus"
            :options="courseFetchStore.statusList"
            placeholder="Select Status"
          />
        </div>

        <div class="modal-footer">
          <button
            type="button"
            @click="clearFilters"
            class="btn btn-secondary me-1"
          >
            Clear
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
